import { makeStyles } from '@mui/styles';
import { Theme as DefaultTheme } from '@mui/material';
import { Color } from 'shared/utils/colors';
const iconStylesCommon = {
  position: 'absolute' as const,
  right: 8,
  fontSize: '1.5rem',
  color: '#757575',
  cursor: 'pointer',
};

const height = 42;

export const useStyles = makeStyles<DefaultTheme, { isMobile: boolean }>(
  (theme) => ({
    searchButton: {
      padding: 0,
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      width: '42px',
      height: `${height}px`,
      minWidth: '42px',
    },
    searchButtonIcon: {
      fontSize: '1.5rem',
      color: '#757575',
      cursor: 'pointer',
    },
    searchWrap: {
      width: 'auto',
      flexShrink: 0,
      flexGrow: 0,
      height: `${height}px`,
      position: 'relative' as const,
      [theme.breakpoints.down(612)]: {
        marginLeft: 0,
        flexGrow: 1,
        width: 0,
        flexShrink: 1,
      },
      display: 'flex',
    },
    searchInputWrap: {
      display: 'flex',
      position: 'relative' as 'relative',
      width: '250px',
      [theme.breakpoints.down(612)]: {
        width: 0,
        flexShrink: 1,
        flexGrow: 1,
      },
    },
    searchIcon: {
      ...iconStylesCommon,
      top: 'calc(50% + 1px)',
      transform: 'translateY(-50%)',
    },
    clearIcon: {
      ...iconStylesCommon,
      top: '50%',
      transform: 'translateY(-50%)',
      '&:hover': {
        color: '#000000',
      },
    },
    searchInput: {
      fontSize: '1rem',
      lineHeight: '1.1rem',
      height: `${height}px`,
      width: '100%',
      boxSizing: 'border-box',
      border: `1px solid ${Color.disabledGray}`,
      borderRadius: 3,
      padding: '10px 32px 10px 10px',
      outline: 'none',
      [theme.breakpoints.down(612)]: {
        width: 0,
        flexShrink: 1,
        flexGrow: 1,
      },
      '&:hover': {
        border: '1px solid #979797',
      },
      '&:active, &:focus': {
        border: `2px solid ${theme.palette.primary.main}`,
        padding: '8px 32px 8px 8px',
      },
      '&::placeholder': {
        color: '#979797',
      },
    },
  })
);
